import { render } from "./Accordian.vue?vue&type=template&id=4d44bae0&scoped=true"
import script from "./Accordian.vue?vue&type=script&lang=js"
export * from "./Accordian.vue?vue&type=script&lang=js"

import "./Accordian.vue?vue&type=style&index=0&id=4d44bae0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d44bae0"]])

export default __exports__